/* eslint-disable */
const user_api_settings = {
user_info_api_domain: 'clp9xkzwe5.execute-api.eu-west-2.amazonaws.com',
user_info_api_token: '4f14127dce6d4276820f56d09ca07af5'
}
export default user_api_settings;
